import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { useFormHandler } from "../../blueplanitUtils/EmployeeSubmitFun";
import { handleClose } from "./HandleClosePop/handleclose";
import { handleKeyDown } from "../../blueplanitUtils/DatePickerAutoformate";
import { setEmploymentDatas } from "../../Slices/employeeslice";
import { DatePickerField, InputField, SelectInput } from "../../blueplanitUtils/InputField";
import Modal from "../../blueplanitUtils/Modal";
import { getOptionsByPath } from "../../utilsdata";
import { EMPLOYEMENT_STATUS_INFO, REHIRE_ELIGIBILITY, RESIGNATION_STATUS, EMPLOYMENT_STATUS } from "../../Dropdownmanager";
 
export const EmployeeStatusModel = () => {
    const { handleSubmit } = useFormHandler()
    const dispatch = useDispatch();
    const [validationErrors, setValidationErrors] = useState({});
    const EmployeeStatusup = useSelector((state) => state.employee.employmentData);
    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
    const [isEmploymentFormValid, setIsEmploymentFormValid] = useState(false);
    const [employmentData, setEmploymentData] = useState({
        employmentStatus: '',
        resignationStatus: '',
        noticePeriod: '',
        resignationDate: '',
        lastWorkingDay: '',
        RehireEligibility: ''
    });
 
    useEffect(() => {
        setEmploymentData(EmployeeStatusup)
    }, [EmployeeStatusup])
 
    const validateEmploymentData = (data) => {
        let errors = {};
        const alphaSpaceHyphenRegex = /^[A-Za-z\s-]+$/;
 
        // Validate employmentStatus
        if (!data.employmentStatus?.trim()) {
            errors.employmentStatus = "Employment status is required.";
        } else if (!alphaSpaceHyphenRegex.test(data.employmentStatus)) {
            errors.employmentStatus = "Accept letters, spaces, or hyphens.";
        }
 
        // Validate resignationStatus
        if (!data.resignationStatus?.trim()) {
            errors.resignationStatus = "Resignation status is required.";
        } else if (!alphaSpaceHyphenRegex.test(data?.resignationStatus)) {
            errors.resignationStatus = "Accept letters, spaces, or hyphens.";
        }
 
        // Validate noticePeriod only if resignationStatus is "Yes"
        if (data.resignationStatus === "Yes") {
            if (!data.noticePeriod || isNaN(data?.noticePeriod) || data?.noticePeriod < 30 || data?.noticePeriod > 90) {
                errors.noticePeriod = "Notice period must be between 30 and 90 days.";
            }
        }
 
        // Validate resignationDate only if resignationStatus is "Yes"
        let resignationDate;
        if (data.resignationStatus === "Yes") {
            if (!data?.resignationDate) {
                errors.resignationDate = "Resignation date is required.";
            } else {
                resignationDate = new Date(data?.resignationDate);
                if (isNaN(resignationDate.getTime())) {
                    errors.resignationDate = "Invalid resignation date.";
                } else {
                    const today = new Date();
                    const twoMonthsAgo = new Date(today);
                    const sixMonthsAhead = new Date(today);
                    twoMonthsAgo.setMonth(today.getMonth() - 2);
                    sixMonthsAhead.setMonth(today.getMonth() + 6);
 
                    if (resignationDate < twoMonthsAgo || resignationDate > sixMonthsAhead) {
                        errors.resignationDate = "Resignation date must be between 2 months ago and 6 months ahead.";
                    }
                }
            }
        }
 
        // Validate lastWorkingDay only if resignationStatus is "Yes"
        if (data.resignationStatus === "Yes") {
            if (!data.lastWorkingDay && data?.noticePeriod && data?.resignationDate) {
                const noticePeriodInDays = parseInt(data.noticePeriod);
                const lastWorkingDate = new Date(resignationDate);
                lastWorkingDate.setDate(resignationDate.getDate() + noticePeriodInDays);
                data.lastWorkingDay = lastWorkingDate.toISOString();
            }
        }
 
        // Validate RehireEligibility
        if (!data.RehireEligibility?.trim()) {
            errors.RehireEligibility = "Please select rehire eligibility.";
        }
 
        return errors;
    };
 
 
 
    const handleEmploymentInputChange = (e) => {
        let name, value;
        if (e && e.target) {
            name = e.target.name;
            value = e.target.value;
        } else if (e instanceof Date) {
            name = e.name;
            value = e;
        } else {
            return;
        }
 
        setEmploymentData((prevData) => {
            let updatedData = { ...prevData, [name]: value };
 
            // If resignationStatus is changed to "No", clear relevant fields
            if (name === "resignationStatus" && value === "No") {
                updatedData = {
                    ...updatedData,
                    resignationDate: null,
                    noticePeriod: '',
                    lastWorkingDay: null
                };
            }
 
            const newErrors = validateEmploymentData(updatedData);
            setValidationErrors(newErrors);
 
            const isValid = Object.keys(newErrors).length === 0;
            setIsEmploymentFormValid(isValid);
 
            return updatedData;
        });
    };
 
 
 
 
    const handleEmploymentSubmit = async (e) => {
        e.preventDefault();
        const { lastWorkingDay, ...restEmploymentData } = employmentData;
        let errors = validateEmploymentData(restEmploymentData);
        const input = {
            employmentStatus: employmentData.employmentStatus,
            resignationStatus: employmentData.resignationStatus,
            noticePeriod: employmentData.noticePeriod,
            resignationDate: employmentData.resignationDate,
            lastWorkingDay: employmentData.lastWorkingDay,
            RehireEligibility: employmentData.RehireEligibility,
        }
        const noErrors = Object.keys(errors).length === 0;
        setValidationErrors(errors);
        try {
            const val = await handleSubmit({
                noErrors,
                formValid: isEmploymentFormValid,
                dataObj: input,
                action: "EmployeeStatus",
                ModalName: "EmployeeModalpopup",
                submitAction: "EmployeeStatusSubmit",
            });
 
            if (val) {
                dispatch(setEmploymentDatas({
                    employmentStatus: employmentData.employmentStatus,
                    resignationStatus: employmentData.resignationStatus,
                    noticePeriod: employmentData.noticePeriod,
                    resignationDate: employmentData.resignationDate,
                    lastWorkingDay: employmentData.lastWorkingDay,
                    RehireEligibility: employmentData.RehireEligibility,
                }));
                setIsEmploymentFormValid(false)
            }
        }
 
        catch (error) {
 
        } finally {
            setIsEmploymentFormValid(false);
        }
    };
 
 
    return (
 
        <Modal id="employment_status_modal"
            title="Employment Status Information"
            handleSubmit={handleEmploymentSubmit}
            handleModalClose={() =>
                handleClose(EmployeeStatusup,
                    setEmploymentData,
                    setValidationErrors)}
            isUserDataValid={false}>
            <div className="form-scroll">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-6">
                                <SelectInput
                                    style={{ width: "100%" }}
                                    label="Employment Status"
                                    name="employmentStatus"
                                    value={employmentData?.employmentStatus}
                                    onChange={(value) =>
                                        handleEmploymentInputChange({
                                            target: {
                                                name: "employmentStatus",
                                                value: value,
                                            }
                                        })
                                    }
                                    options={getOptionsByPath(NestedDatabucket, [EMPLOYEMENT_STATUS_INFO, EMPLOYMENT_STATUS])}
                                    placeholder="Select Employment Status"
                                    formControl={true}
                                    required={true}
                                    error={validationErrors?.employmentStatus}
                                />
 
                            </div>
                            <div className="col-md-6">
                                <SelectInput
                                    style={{ width: "100%" }}
                                    label="Resignation Status"
                                    name="resignationStatus"
                                    value={employmentData?.resignationStatus}
                                    onChange={(value) =>
                                        handleEmploymentInputChange({
                                            target: {
                                                name: "resignationStatus",
                                                value: value,
                                            }
                                        })
                                    }
                                    options={getOptionsByPath(NestedDatabucket, [EMPLOYEMENT_STATUS_INFO, RESIGNATION_STATUS])}
                                    placeholder="Select Resignation Status"
                                    formControl={true}
                                    required={true}
                                    error={validationErrors?.resignationStatus}
                                />
 
 
                            </div>
                            <div className="col-md-6">
                                <InputField
                                    formcontrol="form-control"
                                    type="number"
                                    label="Notice Period"
                                    name="noticePeriod"
                                    required={true}
                                    value={employmentData?.noticePeriod}
                                    onChange={(e) => handleEmploymentInputChange(e)}
                                    error={validationErrors?.noticePeriod}
                                    disabled={employmentData?.resignationStatus === "No"} // 🔹 Disable if "No"
                                />
 
 
                            </div>
                            <div className="col-md-6">
                                <DatePickerField
                                    formcontrol="form-control"
                                    label="Resignation Date"
                                    name="resignationDate"
                                    format="DD/MM/YYYY"
                                    style={{ width: "100%" }}
                                    value={
                                        employmentData?.resignationDate
                                            ? dayjs(employmentData?.resignationDate)
                                            : null
                                    }
                                    onChange={(date) => {
                                        const isoString = date ? date.toISOString() : null;
                                        handleEmploymentInputChange({
                                            target: { name: "resignationDate", value: isoString },
                                        });
                                    }}
                                    onKeyDown={handleKeyDown}
                                    error={validationErrors?.resignationDate}
                                    disabled={employmentData?.resignationStatus === "No"} // 🔹 Disable if "No"
                                />
 
                            </div>
                            <div className="col-md-6">
                                <DatePickerField
                                    formcontrol="form-control"
                                    label="Last Working Day"
                                    required={true}
                                    name="lastWorkingDay"
                                    value={employmentData?.lastWorkingDay ? dayjs(employmentData.lastWorkingDay) : null}
                                    onChange={(date) => {
                                        const isoString = date ? date.toISOString() : null;
                                        handleEmploymentInputChange({
                                            target: {
                                                name: "lastWorkingDay",
                                                value: isoString
                                            }
                                        });
                                    }}
                                    format="DD/MM/YYYY"
                                    style={{ width: "100%" }}
                                    onKeyDown={handleKeyDown}
                                    error={validationErrors?.lastWorkingDay}
                                    disabled={employmentData?.resignationStatus === "No"} // 🔹 Disable if "No"
                                />
 
 
 
                            </div>
                            <div className="col-md-6">
                                <SelectInput
                                    formControl={true}
                                    required={true}
                                    style={{ width: "100%" }}
                                    label="Rehire Eligibility"
                                    name="RehireEligibility"
                                    value={employmentData?.RehireEligibility || ''}
                                    onChange={(e) => handleEmploymentInputChange({
                                        target: {
                                            name: "RehireEligibility",
                                            value: e
                                        }
                                    })}
                                    options={getOptionsByPath(NestedDatabucket, [EMPLOYEMENT_STATUS_INFO, REHIRE_ELIGIBILITY])}
                                    error={validationErrors?.RehireEligibility}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
 